module.exports = __webpack_public_path__ + "img/app-qrcode.500cce17.png";